import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  readonlyField: {
    padding: 'var(--padding-md)',
    backgroundColor: 'var(--color-surface-100)',
    borderRadius: 'var(--border-radius-sm)',
    color: 'var(--color-neutral-800)',
    fontSize: 'var(--text-size-md)',
    marginBottom: 'var(--margin-md)'
  }
}))

function ReadonlyDescriptionEditor ({ field }) {
  const classes = useStyles()

  return (
    <div className={classes.readonlyField}>
      {field.value}
    </div>
  )
}

ReadonlyDescriptionEditor.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.string
  }).isRequired
}

export default ReadonlyDescriptionEditor
